import React from 'react'

const NewButton = React.memo(
  ({
    type = 'button',
    onClick,
    children = 'Button',
    className = '',
    style = {},
    isDisable = false,
    ...rest
  }) => {
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={isDisable}
        className={`group bg-black relative w-full flex items-center gap-1 justify-center py-2.5 px-4 text-base font-semibold rounded-md  text-[#ffffff]  ${className} ${isDisable ? "bg-gray-600 cursor-not-allowed" : ""}`}
        {...rest}
      >
        {children}
      </button>
    )
  }
)

export default NewButton
